import { useEffect, useState } from "react";
import countdownG from "../assets/images/countdown/countdownG.svg";
import countdownO from "../assets/images/countdown/countdownO.svg";
import countdowneEM from "../assets/images/countdown/countdownEM.svg";

const GameCountdown = ({ children, onStart }) => {
  const [countdown, setCountdown] = useState(3);
  const [showGo, setShowGo] = useState(false);
  const [started, setStarted] = useState(false);


  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown((c) => c - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }

    // Quand countdown atteint 0 → afficher "GO!"
    if (countdown === 0 && !showGo && !started) {
      setShowGo(true);
    }
  }, [countdown, showGo, started]);

  useEffect(() => {
    if (showGo) {
      const timer = setTimeout(() => {
        setShowGo(false);   // on cache le GO!
        setStarted(true);   // on démarre le jeu
        if (onStart) onStart();
      }, 1000); // "GO!" reste 1s
      return () => clearTimeout(timer);
    }
  }, [showGo, onStart]);

  if (!started) {
    return (
      <div className="countdown-screen">
        {!showGo ? (
          <div key={countdown} className="countdown-number">
            {countdown}
          </div>
        ) : (
          <div className="countdown-go">
            <img src={countdownG} alt="G" className="countdown-letters"/>
            <img src={countdownO} alt="O" className="countdown-letters" />
            <img src={countdowneEM} alt="!" className="countdown-letters"/>
          </div>
        )}
      </div>
    );
  }

  return <>{children}</>;
};

export default GameCountdown;